import * as React from 'react'
import { HashRouter, Route } from 'react-router-dom'
import ScrollTop from './components/ScrollTop'
import PageLoading from './components/PageLoading'
import Loadable from 'react-loadable'
import Text from './pages/test/Text'
import Auth from './pages/auth/Auth'

// 投保信息 (填写信息)
const insuranceInfo = Loadable({
  loader: () => import('./pages/insuranceInfo/new'),
  loading: PageLoading,
})

// 车险报价服务授权声明
const QuoteItems = Loadable({
  loader: () => import('./pages/quoteItems/index'),
  loading: PageLoading,
})

// 产品详情
const productdetail = Loadable({
  loader: () => import('./pages/productdetail/index'),
  loading: PageLoading,
})

// 投保结算
const insuranceSettle = Loadable({
  loader: () => import('./pages/insuranceSettle/index'),
  loading: PageLoading,
})
const InsuranceFailed = Loadable({
  loader: () => import('./pages/insuranceFailed'),
  loading: PageLoading,
})

// 方案报价（选择方案）
const ProductPrice = Loadable({
  loader: () => import('./pages/productPrice'),
  loading: PageLoading,
})

const SpecialContent = Loadable({
  loader: () => import('./pages/specialContent'),
  loading: PageLoading,
})

const BusinessInstructions = Loadable({
  loader: () => import('./pages/businessInstructions'),
  loading: PageLoading,
})

const InputCode = Loadable({
  loader: () => import('./components/InputCode'),
  loading: PageLoading,
})

const InsuranceInstructions = Loadable({
  loader: () => import('./pages/insuranceInstructions'),
  loading: PageLoading,
})

const FloatInfo = Loadable({
  loader: () => import('./pages/floatInfo'),
  loading: PageLoading,
})

const InsuranceItems = Loadable({
  loader: () => import('./pages/insuranceItems'),
  loading: PageLoading,
})

const ClauseList = Loadable({
  loader: () => import('./pages/clauseList'),
  loading: PageLoading,
})

const RealNameClause = Loadable({
  loader: () => import('./pages/realNameClause'),
  loading: PageLoading,
})

const Order = Loadable({
  loader: () => import('./pages/order/orderList'),
  loading: PageLoading,
})

const AgentLogin = Loadable({
  loader: () => import('./pages/agentLogin'),
  loading: PageLoading,
})
// 确认支付-手机验证
const CustomerIdentity = Loadable({
  loader: () => import('./pages/customerIdentity'),
  loading: PageLoading,
})

const OrderDetail = Loadable({
  loader: () => import('./pages/order/orderDetail'),
  loading: PageLoading,
})

const OrderInvalid = Loadable({
  loader: () => import('./pages/customerIdentity/orderInvalid'),
  loading: PageLoading,
})

const ShareOrder = Loadable({
  loader: () => import('./pages/shareOrder/ShareOrder'),
  loading: PageLoading,
})

const ConfirmOrder = Loadable({
  loader: () => import('./pages/confirm/ConfirmOrder'),
  loading: PageLoading,
})

const PayComplete = Loadable({
  loader: () => import('./pages/payComplete'),
  loading: PageLoading,
})

const Sign = Loadable({
  loader: () => import('./pages/sign/Sign'),
  loading: PageLoading,
})

const AgentQuit = Loadable({
  loader: () => import('./pages/agentQuit'),
  loading: PageLoading,
})

const ApplicantNotSame = Loadable({
  loader: () => import('./pages/applicantNotSame'),
  loading: PageLoading,
})

const LookOnly = Loadable({
  loader: () => import('./pages/lookOnly/LookOnly'),
  loading: PageLoading,
})

const FloatInfoSH = Loadable({
  loader: () => import('./pages/floatInfo/FloatInfoSH'),
  loading: PageLoading,
})

//协议确认页
const ProtocolValidation = Loadable({
  loader: () => import('./pages/protocolValidation/index'),
  loading: PageLoading,
})
// 短链接身份验证
const Kefuidentify = Loadable({
  loader: () => import('./pages/kefuidentify/index'),
  loading: PageLoading,
})
//常见问题
const CommonQuestions = Loadable({
  loader: () => import('./pages/commonQuestions/index'),
  loading: PageLoading,
})
//信息披露
const InfoDisclosure = Loadable({
  loader: () => import('./pages/infoDisclosure/index'),
  loading: PageLoading,
})
const JumpApplet = Loadable({
  loader: () => import('./pages/jumpApplet/index'),
  loading: PageLoading,
})

//支付成功测试页
const PayCompleteTest = Loadable({
  loader: () => import('./pages/payCompleteTest'),
  loading: PageLoading,
})

// 实名失败
const RealNameFailure = Loadable({
  loader: () => import('./pages/realNameFailure'),
  loading: PageLoading,
})

// 实名验证
const IdentityVerification = Loadable({
  loader: () => import('./pages/identityVerification'),
  loading: PageLoading,
})

//支付保费(北京地区专有的)
const PayInsuranceCost = Loadable({
  loader: () => import('./pages/payInsuranceCost/index'),
  loading: PageLoading,
})

//投保预确认(北京地区专有的)
const PreConfirm = Loadable({
  loader: () => import('./pages/preConfirm/index'),
  loading: PageLoading,
})

//支付成功(北京地区专有的)
const InsureSuccess = Loadable({
  loader: () => import('./pages/insureSuccess/index'),
  loading: PageLoading,
})

//信息录入(客服版)
const InfoEntry = Loadable({
  loader: () => import('./pages/infoEntry/index'),
  loading: PageLoading,
})

// 员工车预约投保
const StaffCarInsured = Loadable({
  loader: () => import('./pages/staffCarInsured/index'),
  loading: PageLoading,
})

//h5支付保费
const H5PayPremium = Loadable({
  loader: () => import('./pages/h5PayPremium/index'),
  loading: PageLoading,
})

//上海投保单支付方式选择页
const PayStyleSelect = Loadable({
  loader: () => import('./pages/payStyleSelect/index'),
  loading: PageLoading,
})

//上海投保单支付宝支付码页
const AliPaymentCode = Loadable({
  loader: () => import('./pages/aliPaymentCode/index'),
  loading: PageLoading,
})

// 上海投保单微信支付页面 
const WxPaymentCode = Loadable({
  loader: () => import('./pages/wxPaymentCode/index'),
  loading: PageLoading,
})


//上海投保单pos支付码页
const PosPaymentCode = Loadable({
  loader: () => import('./pages/posPaymentCode/index'),
  loading: PageLoading,
})

//上海投保单投保确认(小程序提示页让走短信)
const ForConfirmation = Loadable({
  loader: () => import('./pages/forConfirmation/index'),
  loading: PageLoading,
})
const routes = (
  <HashRouter>
    <ScrollTop>
      <Route exact path='/productdetail'
        component={productdetail}
      />
      <Route exact path='/insuranceInfo' component={insuranceInfo} />
      <Route exact path='/quoteItems' component={QuoteItems} />
      <Route exact path='/insuranceSettle' component={insuranceSettle} />
      <Route exact path='/insuranceFailed' component={InsuranceFailed} />
      <Route exact path='/productPrice' component={ProductPrice} />
      <Route exact path='/specialContent' component={SpecialContent} />
      <Route
        exact
        path='/businessInstructions'
        component={BusinessInstructions}
      />
      <Route exact path='/InputCode' component={InputCode} />
      <Route
        exact
        path='/insuranceInstructions'
        component={InsuranceInstructions}
      />
      <Route exact path='/floatInfo' component={FloatInfo} />
      <Route exact path='/floatInfoSH' component={FloatInfoSH} />
      <Route exact path='/insuranceItems' component={InsuranceItems} />
      <Route exact path='/clauseList' component={ClauseList} />
      <Route exact path='/realNameClause' component={RealNameClause} />
      <Route exact path='/order' component={Order} />
      <Route exact path='/login' component={AgentLogin} />
      <Route exact path='/test' component={Text} />
      <Route exact path='/orderDetail' component={OrderDetail} />
      <Route exact path='/customerIdentity' component={CustomerIdentity} />
      <Route exact path='/shareOrder' component={ShareOrder} />
      <Route exact path='/confirmOrder' component={ConfirmOrder} />
      <Route exact path='/orderInvalid' component={OrderInvalid} />
      <Route exact path='/sign' component={Sign} />
      <Route exact path='/payComplete' component={PayComplete} />
      <Route exact path='/agentQuit' component={AgentQuit} />
      <Route exact path='/applicantNotSame' component={ApplicantNotSame} />
      <Route exact path='/auth' component={Auth} />
      <Route exact path='/lookOnly' component={LookOnly} />
      <Route exact path='/protocolValidation' component={ProtocolValidation} />
      <Route exact path='/kefuidentify' component={Kefuidentify} />
      <Route exact path='/commonQuestions' component={CommonQuestions} />
      <Route exact path='/infoDisclosure' component={InfoDisclosure} />
      <Route exact path='/jumpApplet' component={JumpApplet} />
      <Route exact path='/payCompleteTest' component={PayCompleteTest} />
      <Route exact path='/realNameFailure' component={RealNameFailure} />

      <Route
        exact
        path='/identityVerification'
        component={IdentityVerification}
      />
      
      <Route exact path='/payInsuranceCost' component={PayInsuranceCost} />
      <Route exact path='/preConfirm' component={PreConfirm} />
      <Route exact path='/insureSuccess' component={InsureSuccess} />
      <Route exact path='/infoEntry' component={InfoEntry} />
      <Route exact path='/staffCarInsured' component={StaffCarInsured} />
      <Route exact path='/h5PayPremium' component={H5PayPremium} />
      <Route exact path='/payStyleSelect' component={PayStyleSelect} />
      <Route exact path='/aliPaymentCode' component={AliPaymentCode} />
      <Route exact path='/wxPaymentCode' component={WxPaymentCode} />
      <Route exact path='/posPaymentCode' component={PosPaymentCode} />
      <Route exact path='/forConfirmation' component={ForConfirmation} />
    </ScrollTop>
  </HashRouter>
)
export default routes 

